// extracted by mini-css-extract-plugin
module.exports = {"project__name":"Projectname_project__name__3qSgJ","into":"Projectname_into__Z4N98"};